import React, { useCallback, useEffect, useState } from "react";
import TableComplex from "../../vapor/tableComplex";
import "./style.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import numeral from "numeral";
import moment from "moment";
import { FormattedMessage, useIntl } from "react-intl";
import { Button } from "@ts-digital/vrc";
import { useDispatch, useSelector } from "react-redux";
import { closeVatSettlement, getWorkspaceSettlement } from "../../../store/actions/reports/vatSettlement";
import { isNumeric } from "../../../libs/utils";

const VatMultiActivityReportPage = ({ currentSettlmentInfo, currentMonthSelected, location, goToDetails, currentSettlement, businessId }) => {
  const intl = useIntl();

  const dispatch = useDispatch();
  const [settlementDetails, setSettlementDetails] = useState([]);
  const [debitAmount, setDebitAmount] = useState(0);
  const [creditAmount, setCreditAmount] = useState(0);
  const [disableButton, setDisableButton] = useState(true);
  const settlementsReport = useSelector(state => state.reports.vat);
  const settlementsList = settlementsReport?.settlements?.settlementApiResList;
  
  useEffect(() => {
    setDisableButton(currentSettlmentInfo?.state?.enableConsolidate ? !currentSettlmentInfo?.state?.enableConsolidate : !currentSettlmentInfo?.state?.enableConsolidate);  
  }, [location, currentSettlmentInfo]);
  
  const currentMonthNumber = currentMonthSelected ? currentMonthSelected : location.pathname.split("vat-detail/")[1];
  // bug on 0 january
  const currentMonth = isNumeric(currentMonthNumber) ? moment(parseInt(currentMonthNumber) === 0 ? 1 :currentMonthNumber , "M").locale("it").format("MMMM") : intl.formatMessage({ id: `reports.vat.${currentMonthSelected}`}) ;  

  let columnsSettlement = [
    {
      title: intl.formatMessage({id: "reports.vat.multiActivity.activity"}),
      width: "35%",
      dataIndex: "activity",
      key: "activity"
    },
    {
      title: intl.formatMessage({id: "reports.vat.multiActivity.amountOnCredit"}),
      width: "16%",
      dataIndex: "creditAmount",
      key: "creditAmount"
    },
    {
      title: intl.formatMessage({id: "reports.vat.multiActivity.amountOnDebit"}),
      width: "16%",
      dataIndex: "debitAmount",
      key: "debitAmount"
    },
    {
      title: "",
      width: "3%",
      dataIndex: "detail",
      key: "detail"
    }
  ];
  
  const onClickClose = () =>{
    setDisableButton(true);
    const currentMonthNumber = currentMonthSelected ? currentMonthSelected : location.pathname.split("vat-detail/")[1];
    const currentMonth = isNumeric(currentMonthNumber) ? moment(currentMonthNumber, "M").locale("en").format("MMMM").toUpperCase() : currentMonthNumber;
    dispatch(closeVatSettlement(
      businessId, location?.state?.year, currentMonth
    ))
      .then(()=>{
        dispatch(getWorkspaceSettlement(location?.state?.year, "VAT_ADVANCE_MONTHLY"));
      })
      .catch(res=>{});
  };

  useEffect(() => {
    // TODO modify it when API will be updated
    let totDebit = 0;
    let totCredit = 0;   
    const arrSettlements = []; 
    currentSettlement?.businessSettlements?.forEach(businessId => {
      totDebit += parseFloat(businessId.vatAmountDebit);
      totCredit += parseFloat(businessId.vatAmountCredit);
      
      arrSettlements.push({
        businessId: businessId.id,
        activity: businessId.businessDescription,
        creditAmount: numeral(parseFloat(Math.abs(businessId.vatAmountCredit))).format("0,0.00"),
        debitAmount: numeral(parseFloat(businessId.vatAmountDebit)).format("0,0.00")
      });     
    });
    setSettlementDetails(arrSettlements);
    setDebitAmount(totDebit);
    setCreditAmount(totCredit);
  }, [JSON.stringify(currentSettlement)]);
  
  const buildDataSource = useCallback(() => {
    
    return settlementDetails.map((item, key) => renderTableRow(item, key));
  },
  [settlementDetails]);

  const renderTableRow = (item, key) => {
    return {
      key: key,
      activity: item.activity,
      creditAmount: <div>{item.creditAmount ? `${item.creditAmount} €`: "-"}</div>,
      debitAmount: <div>{item.debitAmount ? `${item.debitAmount} €`: "-"}</div>,
      detail: <div><FontAwesomeIcon
        icon={["far", "angle-right"]}
        style={{
          color: "#0090d1",
          cursor: "pointer"
        }}
        onClick={() => goToDetails(item.businessId)}
      /></div>
    };
  };

  const renderSummary = () => {
    return [
      "",
      <div key={3}><b>{`${numeral(Math.abs(creditAmount)).format("0,0.00")} €`}</b></div>,
      <div key={4}><b>{`${numeral(Math.abs(debitAmount)).format("0,0.00")} €`}</b></div>,
      <div key={5}><FontAwesomeIcon
        icon={["far", "check"]}
        style={{
          color: "#0090d1"
        }}
      /></div>
    ];
  };
  
  let totalVatAmountCredit = 0;
  let totalVatAmountDebit = 0;        
  let totalCreditAndDebit = 0;

  if (settlementsList){
    const indexMonthSettlement = settlementsList?.findIndex(el => el.month.toString() === currentMonthSelected.toString()) ?? 0;   
    if (indexMonthSettlement > -1){
    
      if (settlementsList[indexMonthSettlement].businessSettlements.length > 1) {
        totalVatAmountCredit= settlementsList[indexMonthSettlement].businessSettlements.reduce((a, b) => {
          return (typeof a === "object" ? a.vatAmountCredit : a) + b.vatAmountCredit;
        });
        totalVatAmountDebit= settlementsList[indexMonthSettlement].businessSettlements.reduce((a, b) => {
          return (typeof a === "object" ? a.vatAmountDebit : a) + b.vatAmountDebit;
        });
      } else if (settlementsList[indexMonthSettlement].businessSettlements.length === 1){
        totalVatAmountCredit = settlementsList[indexMonthSettlement].businessSettlements[0].vatAmountCredit;
        totalVatAmountDebit = settlementsList[indexMonthSettlement].businessSettlements[0].vatAmountDebit;
      }
    }
    totalCreditAndDebit = totalVatAmountCredit - totalVatAmountDebit;
  }
  return (
    <div className="vatHeader">
      <div>
        <div className="title" style={{textTransform: "capitalize"}}>
          {`${currentMonth} ${location?.state?.year || ""}`}
        </div>
        <div style={{display: "flex"}}>
          <div style={{marginRight: "40px"}}>
            <div className="title">
              <FormattedMessage id={`reports.vat.multiActivity.${currentSettlement.previousPeriodCredit ? "previousVatCredit" : "previousVatDebit"}`} />
            </div>
            <div className="subtitle">
              {numeral(Math.abs((currentSettlement.previousPeriodCredit ? currentSettlement.previousPeriodCredit : currentSettlement.previousPeriodDebt) ?? 0)).format("0,0.00")}
            </div>
          </div>
          <div>
            <div className="title">
              <FormattedMessage id={`reports.vat.multiActivity.${totalCreditAndDebit>0 ? "amountOnCredit" : "amountOnDebit"}`
              } />
            </div>
            <div className="subtitle">
              {numeral(Math.abs((totalCreditAndDebit) ?? 0)).format("0,0.00")}
            </div>
          </div>
        </div>
      </div>
      <TableComplex
        columns={columnsSettlement}
        summary={renderSummary()}
        dataSource={buildDataSource()} />
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          paddingTop: 50
        }}
      >
        <Button kind="primary" onClick={()=>onClickClose()} disabled={disableButton}>
        Consolida
        </Button>
      </div>
     
    </div>
  );
};
export default VatMultiActivityReportPage;
